import React from 'react';
import { styled } from 'styled-components';
//import { classic } from '~/themes/classic';

type IProps = {
  children: React.ReactNode;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function SquareItem({
  children
}: TProps) {
  return (
    <Container>
        <SDivContent>{children}</SDivContent>
    </Container>
  );
}

const Container = styled.div<{ disabled?: boolean }>`
  height: 90%;
  position: relative;
  aspect-ratio: 1/1;
  width: auto;


  @media screen and (orientation: portrait) {
    width: 100%;
    aspect-ratio: auto;
    height: 90%;
  }
`;

const SDivContent = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;`
    




